import { createSlice } from "@reduxjs/toolkit"

import { API_STATUS } from "../types"

import { instrumentSliceInitialState } from "./types"
import { ACTION_TYPE_PARENT, clearSelectedInstrument, setSelectedInstrument } from "./actions"

const INITIAL_STATE: instrumentSliceInitialState = {
  status: API_STATUS.idle,
  isLoading: false,
  error: null,
  selectedInstrument: null
}

/* eslint-disable no-param-reassign */
export const instrumentSlice = createSlice({
  name: 'Instrument',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(setSelectedInstrument.fulfilled, (state, action: any) => {
        state.status = API_STATUS.success
        state.selectedInstrument = action.payload
      })
      .addCase(setSelectedInstrument.pending, (state) => {
        state.status = API_STATUS.loading
      })
      .addCase(setSelectedInstrument.rejected, (state, action: any) => {
        state.status = API_STATUS.failed
        state.error = action.payload
      })

      .addCase(clearSelectedInstrument.fulfilled, (state, action: any) => {
        state.status = API_STATUS.success
        state.selectedInstrument = action.payload
      })
      .addCase(clearSelectedInstrument.pending, (state) => {
        state.status = API_STATUS.loading
      })
      .addCase(clearSelectedInstrument.rejected, (state, action: any) => {
        state.status = API_STATUS.failed
        state.error = action.payload
      })
  }
})
/* eslint-disable no-param-reassign */

// export const { } = organizationSlice.actions

export default instrumentSlice.reducer

// export const selectedAllOrganizations = (state: RootState) => state[ACTION_TYPE_PARENT].organizationList
